import { capitalize, toLower } from 'lodash';

import { QueryStringFilter, QueryStringParam } from './types';

const delimiter = '-';

interface ISortOrderSerializer extends QueryStringFilter<GQL.ISearchSortOrder> {
  unserializeStr: (str: string) => GQL.ISearchSortOrder;
}

export const SortOrderSerializer: ISortOrderSerializer = {
  serialize(sort) {
    if (!sort) { return ''; }

    return toLower(`${sort.field}${delimiter}${sort.order}`);
  },

  unserialize(query) {
    try {
      if (QueryStringParam.SortOrder in query) {
        const sortOrderStr = query[QueryStringParam.SortOrder];
        return this.unserializeStr(sortOrderStr);
      }
    } catch (e) {
      console.error(e);
    }

    return {
      field: GQL.SearchSortField.Featured,
      order: GQL.SearchSortOrderDirection.Desc,
    };
  },

  unserializeStr(sortOrderStr) {
    const [field, order] = sortOrderStr.split(delimiter);
    return {
      field: capitalize(field) as GQL.SearchSortField,
      order: capitalize(order) as GQL.SearchSortOrderDirection,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/sortOrder.ts